export default [
  {
    id: 1,
    name: "Toulouse",
    boundingbox: [[1.2, 43.51], [1.64, 43.77]],
    theme: ["shortest", "culture", "nightlife", "nature"]
  },
  {
    id: 2,
    name: "Montpellier",
    boundingbox: [[3.65, 43.46], [4.07, 43.77]],
    theme: [
      "shortest",
      "culture",
      "nightlife",
      "nature",
      "montpellier_noise_2017"
    ]
  },
  {
    id: 3,
    name: "Bordeaux",
    boundingbox: [[-0.89, 44.74], [-0.44, 45.05]],
    theme: ["shortest", "culture", "nightlife", "nature"]
  },
  {
    id: 4,
    name: "Nantes",
    boundingbox: [[-1.93, 47.1], [-1.35, 47.36]],
    theme: ["shortest", "culture", "nightlife", "nature"]
  }
];



// WEBPACK FOOTER //
// ./src/config/city.js